import { SVGIconComponent } from './types';

export const HubTypeLockersHub: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.999 11.269 18 16.924a.576.576 0 0 1-.576.576h-3.483v-6.231zm-13.944 0V17.5H.575A.576.576 0 0 1 0 16.924V11.27zm4.648 0V17.5H4.647v-6.231zm4.668 0V17.5H9.282v-6.231zM8.703 9.575v1.142H4.647V9.575zm4.668 0v1.142H9.282V9.575zm4.628 0v1.142h-4.058V9.575zM4.055 6.166v4.551H0v-4.55zm-1.73 3.86h-.602a.142.142 0 1 0 0 .283h.602a.142.142 0 1 0 0-.283m.278-3.293H1.447a.29.29 0 0 0-.288.288v2.267c0 .159.13.288.288.288h1.156a.29.29 0 0 0 .288-.288V7.02a.29.29 0 0 0-.288-.288M18 7.88v1.128h-4.058V7.879zm-4.628 0v1.128h-4.09V7.879zm-4.668 0v1.128H4.647V7.879zm4.668-1.713v1.156h-4.09V6.166zm4.628 0v1.156h-4.058V6.166zm-9.296 0v1.156H4.647V6.166zM4.055 3.343v2.256H0V3.343zm4.648 0v2.256H4.647V3.343zm4.668 0v2.256H9.282V3.343zm4.629 0L17.999 5.6h-4.058V3.343zM4.056.5l-.001 2.263H0V1.076C0 .758.258.5.576.5zm4.648 0-.001 2.263H4.647V.5zm4.668 0-.001 2.263H9.282V.5zm4.052 0c.318 0 .576.258.576.576v1.687h-4.059V.5z"
    />
  </svg>
);
